import axios from "axios";

const api = axios.create({
  // baseURL: "http://192.168.3.7:3340",
  baseURL: "https://apcap-apiv1.yazon.com.br/",
  headers: {
    "Content-Type": "application/json",
  },
});
 
export default api;
